import type { Location } from "react-router-dom";
import { REDIRECT_TO_SESSION_STORE_KEY } from "./consts";

/**
 * Remembers where a logged-out visit was headed, for App's post-login effect to navigate back to. The whole address,
 * query and hash too: an emailed or texted deep link (`?tab=settings`, `?chat=open`) must land on the
 * same view after login, not on its page's default.
 */
export const rememberRedirectAfterLogin = (location: Pick<Location, "pathname" | "search" | "hash">): void =>
	sessionStorage.setItem(REDIRECT_TO_SESSION_STORE_KEY, `${location.pathname}${location.search}${location.hash}`);
